module.exports = __webpack_public_path__ + "img/Wanita.df93bfef.svg";